/**
 *@author shaolei
 *@date 2020/04/01
 *@file_name:footer
 *@Description: 底部组件
 */
<template>
  <footer>
    <div class="footer">
      <div class="left">
        <div class="link">
          <a target="_blank" href="http://www.yundaex.com">韵达官网</a>
          <router-link
              :to="{ path: item.paht }"
              v-for="(item,index) in tabArry"
              :key="index"
              tag="a"
            >{{item.title}}</router-link>
        </div>
        <div class="record">
          韵达版权所有2019-2021 Copyright © www.yundaex.com, All Rights Reserved.  |  沪ICP备16000745号
        </div>
      </div>
      <div class="right">
        <div class="qq">
          <a target="_blank" href="//shang.qq.com/wpa/qunwpa?idkey=a9e7dbf9a13307c56f2cbd72250f849da9e665661f1710d3db085812a408d5cc">
            <img border="0" src="@/assets/images/icon-qq.png" alt="韵达开放平台交流群①" title="韵达开放平台交流群①">
          </a>
        </div>
        <div class="info">
          <div>开放平台QQ群</div>
          <div>84592633</div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      tabArry: [
        {
          title: "API文档",
          paht: "/api"
        },
        {
          title: "帮助中心",
          paht: "/help"
        }
      ]
    };
  },
  mounted() {},
  methods: {}
};
</script>
<style lang="less" scoped>
footer{
  background: #303030;
  height: 140px;

  .footer{
    width: 1200px;
    margin: 0 auto;
    display: flex;

    .left{
      flex: 1;
      padding: 40px 0;

      .link{
        color: #fff;
        
        a{
          color: #fff;
          font-size: 14px;
          display: inline-block;
          position: relative;
          padding-right: 10px;
        }

        :nth-child(2) {
          padding: 0 10px;
          text-align: center;

          &::before{
            content: "";
            position: absolute;
            height: 12px;
            width: 1px;
            background: rgba(255,255,255,0.6);
            right: 0;
            top: 50%;
            margin-top: -6px; 
          }
          &::after{
            content: "";
            position: absolute;
            height: 12px;
            width: 1px;
            background: rgba(255,255,255,0.6);
            left: 0;
            top: 50%;
            margin-top: -6px; 
          }
        }

        :nth-child(3){
          padding-left: 10px;
        }
      }
      
      .record{
        color: rgba(255,255,255,0.6);
        font-size: 14px;
        margin-top: 15px;
      }
    }
    .right{
      flex-basis: 280px;
      display: flex;
      padding: 40px 0;

      .qq{
        img{
          width: 60px;
          height: 60px;
        }
      }

      .info{
        font-size:14px;
        color:rgba(255,255,255,1);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 5px 0;
        margin-left: 20px;
        padding-left: 20px;
        position: relative;

        &::after{
          content:'';
          position: absolute;
          left: 0;
          height: 40px;
          width: 1px;
          background: rgba(255,255,255,0.2);
          top: 50%;
          margin-top: -20px;
        }
      }
    }
  }
}
</style>